var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar d-none d-lg-block"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("\n                Introducing Chat by tech.ai: Whatever you need, just ask it.\n                "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("learn more")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa5ea26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_components/home-5/TopHeader.vue
// module id = null
// module chunks = 